import * as React from "react";
import glass_mode from "../../../UI/general/glass-mode.svg";
import dark_mode from "../../../UI/general/dark-mode.svg";
import light_mode from "../../../UI/general/light-mode.svg";

declare const window: any;

export default function HorizontalBarContainer({
  setSubMenuSelected,
  setSubMenuSelectedTemp,
  colors,
  menus,
  builderLogo,
  projectLogo,
  projectLogosMultiples,
  theme,
  active,
  setMenuSelected,
  menuSelected,
  setFrame,
  setGaleriaSelected,
  introView,
  isHidden,
  setIsHidden,
  setIsSideBarVertical,
  isLoading,
  active_builder_logo,
  logo_invertido,
  version,
  hotspotsSelected,
  setHotspotsSelected,
  subMenuSelected,
  isSelectedAptoView,
  setIsSelectedAptoView,
  isGuide,
  setIsGuide,
  selectedLanguage,
  multiLanguage,
}: any) {
  const [animationIntro, setAnimationIntro] = React.useState(false);
  const [detailedTitle, setDetailedTitle] = React.useState("");
  //Diego: Reactivar
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [startXOther, setStartXOther]: any = React.useState(0);

  React.useEffect(() => {
    if (!introView) {
      let hrr: any = document.querySelector(".horizontal-bar-container");
      hrr.style.bottom = "-7.625rem";
      setIsHidden(true);
      setTimeout(() => {
        hrr.style.removeProperty("bottom");
        setAnimationIntro(true);
        setIsHidden(false);
      }, 500);
    }
  }, [introView]);

  React.useEffect(() => {
    if (!isSelectedAptoView) {
      setDetailedTitle("");
      return;
    }

    for (const value of isSelectedAptoView.values) {
      if (value.hierarchicalLevel.toLocaleLowerCase() === "jerarquico #1") {
        setDetailedTitle(value.value + " - " + isSelectedAptoView.property);
        break;
      }
    }
  }, [isSelectedAptoView]);

  React.useEffect(() => {
    setTimeout(() => {
      //console.log("aqui");

      setIsGuide(false);
    }, 5000);
  }, []);

  const handleAddDown = (val: boolean) => {
    var sidebarOriginal: any = document.querySelector(
      ".horizontal-bar-container"
    );
    if (val) {
      sidebarOriginal.classList.remove("down");
      sidebarOriginal.classList.add("animation");
    } else {
      sidebarOriginal.classList.remove("animation");
      sidebarOriginal.classList.add("down");
    }
    var sidebar: any = document.querySelector(".horizontal-bar-container.down");
    var sidebarInternal = document.querySelector(
      ".horizontal-bar-internal-container"
    );

    if (sidebar) {
      sidebar.style.bottom = "-5.3125rem";
    } else {
      sidebarOriginal.style.removeProperty("bottom");
    }
  };

  const darkenColor = (color: string, percent: number) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  //console.log("aqui");

  return (
    <div
      className={`horizontal-bar-container ${
        isHidden || isLoading ? "down" : "animation"
      } ${animationIntro ? active + " animation" : active}`}
    >
      {isGuide && isSelectedAptoView === null && (
        <div
          className={`horizontal-bar-guia ${theme} ${menuSelected}`}
          onClick={() => {
            setIsHidden(
              !isHidden
            ); /* , !isHidden ? setIsSideBarVertical(false) : null */
          }}
        >
          <img
            src={
              theme === "Light"
                ? light_mode
                : theme === "Dark"
                ? dark_mode
                : glass_mode
            }
            alt=""
          />
          <p className="horizontal-bar-guia-text">
             {selectedLanguage?.is_main
                                  ? "Arrastra el cursor para rotar 360°"
                                  : selectedLanguage?.language_code === "en" ? "Drag the cursor to rotate 360°" : "Arrastra el cursor para rotar 360°"}
          </p>
        </div>
      )}
      {menuSelected === "Inmuebles" &&
        subMenuSelected !== "" &&
        detailedTitle === "" &&
        !isLoading && (
          <div
            className={`horizontal-bar-jerarquico ${theme} ${menuSelected}`}
            onClick={() => {
              setIsHidden(
                !isHidden
              ); /* , !isHidden ? setIsSideBarVertical(false) : null */
            }}
          >
            <p className="horizontal-bar-jerarquico-text">
              {detailedTitle !== ""
                ? detailedTitle
                : detailedTitle === ""
                ? subMenuSelected
                : hotspotsSelected?.hotspot_name}{" "}
              |{" "}
              <i
                className="fas fa-xmark"
                onClick={() => {
                  if (detailedTitle === "") {
                    setMenuSelected("");
                    setSubMenuSelected("");
                    setFrame(1);
                    setHotspotsSelected(null);
                  }
                  setIsSelectedAptoView(null);
                }}
              ></i>
            </p>
          </div>
        )}
      {menuSelected === "Inmuebles" && detailedTitle !== "" && !isLoading && (
        <div
          className={`horizontal-bar-jerarquico ${theme} ${menuSelected}`}
          onClick={() => {
            setIsHidden(
              !isHidden
            ); /* , !isHidden ? setIsSideBarVertical(false) : null */
          }}
        >
          <p className="horizontal-bar-jerarquico-text">
            {detailedTitle !== ""
              ? detailedTitle
              : detailedTitle === ""
              ? subMenuSelected
              : hotspotsSelected?.hotspot_name}{" "}
            |{" "}
            <i
              className="fas fa-xmark"
              onClick={() => {
                if (detailedTitle === "") {
                  setMenuSelected("");
                  setSubMenuSelected("");
                  setFrame(1);
                  setHotspotsSelected(null);
                }
                setIsSelectedAptoView(null);
              }}
            ></i>
          </p>
        </div>
      )}
      <div
        className={`horizontal-bar-toggle ${theme} ${menuSelected}`}
        onClick={() => {
          setIsHidden(
            !isHidden
          ); /* , !isHidden ? setIsSideBarVertical(false) : null */
        }}
      >
        <i
          style={{ transform: isHidden ? "rotate(0deg)" : "rotate(180deg)" }}
          className={`fa-solid fa-chevron-up`}
        ></i>
      </div>
      <div
        className={`horizontal-bar-internal-container ${theme} ${menuSelected}`}
      >
        <div
          className={`horizontal-bar-toggle-internal ${theme}`}
          onClick={() => setIsHidden(!isHidden)}
        ></div>
        <div
          className="horizontal-bar-internal-container-final"
          style={{
            justifyContent: menus.length > 0 ? "space-between" : "center",
          }}
        >
          <div className="horizontal-bar-logos">
            <div style={logo_invertido ? { flexDirection: "row-reverse" } : {}}>
              {projectLogosMultiples?.length === 0 && active_builder_logo ? (
                <img
                  src={`${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net/"
                  }${builderLogo}`}
                  alt=""
                />
              ) : null}
              <img
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://d1bsymnertnea6.cloudfront.net/"
                }${projectLogo}`}
                alt=""
              />
            </div>
          </div>
          {menus.map((menu: any, index: number) => (
            <div
              className={`horizontal-bar-menu ${
                menu.name === menuSelected ? "active" : ""
              }`}
              style={{
                "--main-buttons": colors?.main_buttons,
                width: "fit-content",
                display: "flex", // 👈 cambio aquí
                flexDirection: "column", // 👈 fuerza icono arriba, texto abajo
                alignItems: "center", // 👈 centra horizontalmente
                textAlign: "center",
              }}
              onClick={() => {
                setMenuSelected(menu.name === menuSelected ? "" : menu.name);
                setSubMenuSelected("");
                setSubMenuSelectedTemp("");
              }}
            >
              <img
                src={
                  version < "2.1.0"
                    ? menu.icono
                    : `${
                        window.hybrid
                          ? "./"
                          : "https://d1bsymnertnea6.cloudfront.net"
                      }${menu.icono}`
                }
                alt={menu.name}
                width={30}
              />
              <span>{selectedLanguage?.is_main
                                  ? (menu.label ? menu.label : menu.name)
                                  : menu.i18n?.[
                                      selectedLanguage?.language_code
                                    ] ?? (menu.label ? menu.label : menu.name)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
